import DialogBase from "@components/ui/dialog-base";
import { useFileToStorydocStoreShallow } from "../stores";

export const UploadingStep = () => {
  const { statusMessage, uploadProgress } = useFileToStorydocStoreShallow(
    (s) => ({
      statusMessage: s.statusMessage,
      uploadProgress: s.uploadProgress,
    }),
  );
  const percent = Math.round(uploadProgress * 100);

  return (
    <DialogBase.Content className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col tw-items-center tw-p-0">
      <div className="tw-flex tw-h-[144px] tw-w-[528px] tw-max-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-5 tw-rounded-2xl tw-bg-violet-50 tw-px-32 tw-pb-4 tw-shadow-2xs tw-outline-dashed tw-outline-1 !tw-outline-offset-0 tw-outline-violet-700/20">
        <p className="tw-m-0 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-leading-5 tw-text-blue">
          {statusMessage}
        </p>
        <div
          role="progressbar"
          aria-label={statusMessage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
          className="tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-violet-950/15"
        >
          <div
            className="tw-h-full tw-rounded-full tw-bg-violet-700 tw-transition-[width] tw-duration-500 tw-ease-out"
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </DialogBase.Content>
  );
};
